<p-accordion
  *ngIf="!isLoading"
  [multiple]="true"
  [(activeIndex)]="activeIndex">
  <p-accordionTab header="Aquatic vertebrate and invertebrate">

    <app-era-pec-ecc-aquatic
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [menuService]="menuService"
      [selectedProject]="selectedProject"
      [geography]="geography"
      [columnDefs]="aquaticColumnDef"
      [type]="'Aquatic'"
    />

  </p-accordionTab>
  <p-accordionTab
    *ngIf="geography.geographyName === 'USA'"
    header="Terrestrial plants">

    <app-era-pec-ecc-aquatic
      [isProjectOwnershipValid]="isProjectOwnershipValid"
      [menuService]="menuService"
      [selectedProject]="selectedProject"
      [geography]="geography"
      [columnDefs]="plantAssessmentToolTpezColumnDef"
      [type]="'TPEZ'"
    />

  </p-accordionTab>
  <p-accordionTab
  *ngIf="geography.geographyName === 'USA'"
  header="Wetland plants">

  <app-era-pec-ecc-aquatic
    [isProjectOwnershipValid]="isProjectOwnershipValid"
    [menuService]="menuService"
    [selectedProject]="selectedProject"
    [geography]="geography"
    [columnDefs]="plantAssessmentToolWpezColumnDef"
    [type]="'WPEZ'"
  />

</p-accordionTab>
</p-accordion>

<app-loading
  *ngIf="isLoading"
  class="flex align-items-center justify-content-center"
/>
